export default __webpack_public_path__ + "static/media/wrong.6f21c4e4.mp3";